import { PREMIUM_SIZES, getPremiumSize, supplierPriceCAD, SCREEN_USD_PER_FOOT, OPTION_MARKUP } from '../utils/pergolaCatalog';

export interface ModelCard {
  id: string; name: string; price: number; installCost: number;
  description: string; tagline: string; badge?: string; bullets: string[];
  bestFor: string; includes: string[]; warrantyYears: number;
}
export interface AddOn {
  id: string; name: string; price: number; hasQuantity?: boolean;
  premiumOnly?: boolean; originalPrice?: number; quoteOnly?: boolean;
  perLinearFoot?: boolean;
}

const models: ModelCard[] = [{
  id: 'premium', name: 'Premium', price: PREMIUM_SIZES[0].priceCAD, installCost: 0,
  description: 'Motorized comfort with an instant installed estimate.',
  tagline: 'Make more of your outdoor space.', badge: 'Motorized',
  bullets: ['120 kg/m² / 24.6 psf load rating', 'Motorized double-layer louvers', 'White perimeter lighting included', 'Standard installation and delivery included'],
  bestFor: 'Patios, entertaining spaces and outdoor living',
  includes: ['Aluminum frame', 'Motorized louvers', 'White perimeter lighting', '3 m height'],
  warrantyYears: 10,
}];
const addons: AddOn[] = [
  { id: 'privacy-shade', name: 'Privacy Shade', price: supplierPriceCAD(SCREEN_USD_PER_FOOT, OPTION_MARKUP), hasQuantity: true, perLinearFoot: true },
  { id: 'aluminum-panels', name: 'Aluminum Panels', price: 0, hasQuantity: true, quoteOnly: true },
  { id: 'rain-sensor', name: 'Rain Sensor', price: 0, quoteOnly: true },
  { id: 'heaters', name: 'Heaters', price: 0, hasQuantity: true, quoteOnly: true },
  { id: 'led-upgrade', name: 'White Perimeter Lighting', price: 0 },
];

// A single approved catalogue feeds both the quote form and marketing pages.
// Unknown options stay quote-only until a supplier USD cost is provided.
export const usePergolaModels = () => ({
  models, addons,
  getPriceForSize: (model: string, size: string) => model === 'premium' ? getPremiumSize(size)?.priceCAD ?? 0 : 0,
  getCostPriceForSize: (model: string, size: string) => model === 'premium' ? getPremiumSize(size)?.materialsCAD ?? 0 : 0,
  isLoading: false, error: null,
});